export interface Story {
  id: number;
  tag: string;
  tagTone?: "primary" | "accent" | "secondary";
  title: string;
  summary: string;
  time: string;
  reads: string;
  hot?: number;
  image?: string;
}

/* 全站快讯条（虚构） */
export const tickerNews: string[] = [
  "独家：某新晋顶流被拍到深夜出入录音棚，被指为跨界出道铺路",
  "吃瓜预警：一档综艺录制现场突然叫停，疑似嘉宾临时离场内幕流出",
  "内幕：头部MCN被爆暗中更换网红签约金分成比例，主播排队跳槽",
  "独家：时尚周后台助理晒出未公开物料，品牌方紧急公关删帖",
  "曝料：两部待播剧导演被换，制作方回应口径前后矛盾惹议",
  "猛料：某直播间选品负责人被指收高额坑位费压价压量引商家不满",
  "最新：两家经纪公司被曝互相挖角，旗下艺人同框同款热搜不断",
];

/* 头条双栏右侧头条速览列表（虚构） */
export const leadList: Story[] = [
  {
    id: 1,
    tag: "独家",
    title: "开播前三天被换角，是剧本还是资本？这部戏台前幕后都在等一句话",
    summary: "项目立项至今换过两轮阵容，筹备群消息被曝截图流传，出品方至今未正面回应。",
    time: "12 分钟前",
    reads: "8.2万",
  },
  {
    id: 2,
    tag: "曝光",
    title: "真人秀同款行程被扒：录制期住同一酒店，前后脚退房引发同框猜测",
    summary: "行程单上的入住与退房时间高度重合，粉丝与路人在评论区各执一词。",
    time: "38 分钟前",
    reads: "6.7万",
  },
  {
    id: 3,
    tag: "内幕",
    title: "品牌代言续约谈崩，顶流商务报价被曝从年初一路走高再回落",
    summary: "多位商务人士称其对外报价浮动明显，续约团队口径不一，外界普遍观望。",
    time: "1 小时前",
    reads: "5.1万",
  },
];

/* 头版头条大图故事 */
export const heroLead: Story = {
  id: 0,
  tag: "头版头条",
  tagTone: "primary",
  title: "一张后台合照引爆全网：两位许久不合作的顶流被曝同赴同一饭局",
  summary:
    "知情人士晒出当晚包间预订记录与代驾单，双方团队一改往日沉默，先后发出同款「勿传谣」声明，前后脚时间差被网友逐字逐句对比。想抢在别人之前吃瓜，先看清这张图里藏了多少细节。",
  time: "8 分钟前",
  reads: "12.6万",
  image:
    "https://readdy.ai/api/search-image?query=cinematic%20editorial%20photojournalism%20scene%20of%20a%20glamorous%20hotel%20restaurant%20private%20dining%20room%20at%20night%20with%20warm%20candlelight%20on%20a%20table%20for%20two%20set%20with%20two%20place%20settings%20and%20red%20wine%2C%20deep%20red%20and%20amber%20color%20palette%2C%20soft%20bokeh%20background%20lights%2C%20dramatic%20side%20lighting%2C%20high%20contrast%2C%20moody%20cinematic%20atmosphere%2C%20ultra%20detailed%20professional%20press%20photography%20with%20shallow%20depth%20of%20field&width=1600&height=1000&seq=hero-lead-2026&orientation=landscape",
};

/* 独家大曝光 大图卡片流（虚构） */
export const featuredNews: Story[] = [
  {
    id: 11,
    tag: "独家",
    tagTone: "primary",
    title: "幕后剪辑师离职晒出未用花絮：成片里被剪掉的那段，藏着更大分歧",
    summary: "一条15秒未播出画面在深夜发酵，节目组回应称「技术原因」，评论区并不买账。",
    time: "26 分钟前",
    reads: "9.8万",
    image:
      "https://readdy.ai/api/search-image?query=editorial%20photojournalism%20of%20a%20dark%20video%20editing%20suite%20with%20multiple%20monitors%20glowing%20and%20timeline%20tracks%20visible%2C%20moody%20studio%20lighting%2C%20deep%20red%20and%20amber%20color%20grading%2C%20high%20contrast%20cinematic%20tones%2C%20professional%20press%20photography%2C%20shallow%20depth%20of%20field%2C%20dramatic%20shadows&width=1500&height=950&seq=feature-exclusive-01&orientation=landscape",
  },
  {
    id: 12,
    tag: "曝光",
    tagTone: "accent",
    title: "跨城商演同一机位拍到两版出场：是剪辑套用，还是另有安排",
    summary: "同款造型同款走位被剪进两场不同城市的演出，团队解释口径前后反复。",
    time: "51 分钟前",
    reads: "7.4万",
    image:
      "https://readdy.ai/api/search-image?query=editorial%20press%20photo%20of%20a%20silhouetted%20performer%20on%20a%20dark%20concert%20stage%20with%20a%20single%20bright%20spotlight%20and%20smoke%2C%20deep%20red%20and%20warm%20amber%20stage%20lighting%2C%20dramatic%20high%20contrast%2C%20cinematic%20atmosphere%2C%20professional%20magazine%20photography%2C%20moody%20and%20gritty&width=1500&height=950&seq=feature-expose-02&orientation=landscape",
  },
  {
    id: 13,
    tag: "内幕",
    tagTone: "secondary",
    title: "选秀回归传闻再起：节目组旧档期表被翻出，导师名单传了三个版本",
    summary: "招商PPT在某内部群被曝传播，档期与导师都还没盖章，网上已吵成一锅粥。",
    time: "1 小时前",
    reads: "6.2万",
    image:
      "https://readdy.ai/api/search-image?query=editorial%20photojournalism%20of%20a%20casting%20audition%20room%20with%20empty%20judge%20seats%20and%20a%20single%20microphone%20stand%20in%20front%2C%20warm%20amber%20overhead%20lights%20casting%20long%20shadows%2C%20deep%20red%20accents%2C%20cinematic%20high%20contrast%2C%20professional%20press%20photography%2C%20moody%20atmosphere&width=1500&height=950&seq=feature-inside-03&orientation=landscape",
  },
  {
    id: 14,
    tag: "独家",
    tagTone: "primary",
    title: "顶流机场穿搭同款秒光：被扒出的不是品牌，而是背后选款逻辑",
    summary: "同款货架瞬间售罄，网友开始盘算：带货风口下的选款，到底由谁拍板。",
    time: "1 小时前",
    reads: "8.9万",
    image:
      "https://readdy.ai/api/search-image?query=editorial%20fashion%20photojournalism%20of%20an%20empty%20airport%20terminal%20glass%20wall%20at%20dawn%20with%20soft%20warm%20light%20and%20a%20lone%20luggage%20cart%2C%20minimal%20moody%20composition%2C%20amber%20and%20deep%20red%20tone%2C%20high%20contrast%20cinematic%20lighting%2C%20professional%20magazine%20photography%2C%20shallow%20depth%20of%20field&width=1500&height=950&seq=feature-style-04&orientation=landscape",
  },
];

/* 明星网红 分线流（虚构） */
export const starNews: Story[] = [
  {
    id: 21,
    tag: "明星",
    title: "戏约、代言、红毯一个不落，这位「劳模」最近为何反而查无此人",
    summary: "曾经活跃的名字近期淡出热搜，多方打听都只得到一句「档期不方便」。",
    time: "1 小时前",
    reads: "6.8万",
    image:
      "https://readdy.ai/api/search-image?query=editorial%20celebrity%20photojournalism%20of%20an%20empty%20red%20carpet%20with%20velvet%20rope%20stanchions%20and%20backdrop%20under%20warm%20spotlights%2C%20no%20people%20present%2C%20moody%20dramatic%20lighting%2C%20deep%20red%20and%20amber%20palette%2C%20high%20contrast%2C%20professional%20press%20photography%2C%20cinematic%20atmosphere&width=1200&height=760&seq=star-01&orientation=landscape",
  },
  {
    id: 22,
    tag: "网红",
    title: "停更三周后首发声，评论区清一色「等解释」：他把话说全了吗",
    summary: "长文配九图看似诚恳，粉丝却逐帧找出前后版本用词不一致的地方。",
    time: "2 小时前",
    reads: "5.9万",
    image:
      "https://readdy.ai/api/search-image?query=editorial%20photojournalism%20of%20a%20phone%20screen%20close%20up%20showing%20a%20blurred%20long%20text%20post%20with%20scroll%20bar%2C%20lit%20by%20warm%20desk%20lamp%20light%2C%20deep%20red%20and%20amber%20tones%2C%20high%20contrast%20cinematic%20mood%2C%20professional%20magazine%20photography%2C%20shallow%20depth%20of%20field&width=1200&height=760&seq=star-02&orientation=landscape",
  },
  {
    id: 23,
    tag: "明星",
    title: "同一天两个热搜词条方向相反：公关团队在线「打架」还是炒作",
    summary: "一边是澄清一边是实锤，同一团队两套口径，看得路人都开始心疼数据组。",
    time: "2 小时前",
    reads: "7.1万",
    image:
      "https://readdy.ai/api/search-image?query=editorial%20press%20photo%20of%20two%20glowing%20smartphones%20side%20by%20side%20showing%20conflicting%20social%20news%20headlines%20on%20a%20dark%20table%2C%20warm%20amber%20and%20deep%20red%20lighting%2C%20dramatic%20high%20contrast%2C%20professional%20photojournalism%2C%20cinematic%20moody%20atmosphere%2C%20shallow%20depth%20of%20field&width=1200&height=760&seq=star-03&orientation=landscape",
  },
  {
    id: 24,
    tag: "网红",
    title: "带货翻车后一个月，这位主播的复出预告把「诚意」挂在嘴上",
    summary: "预告片里又是鞠躬又是自省，可网友只回一句：先把售后处理明白再说。",
    time: "3 小时前",
    reads: "4.6万",
    image:
      "https://readdy.ai/api/search-image?query=editorial%20photojournalism%20of%20a%20live%20streaming%20studio%20with%20empty%20seats%20and%20a%20lit%20ring%20light%20and%20boxes%20stacked%20in%20background%2C%20moody%20warm%20lighting%2C%20deep%20red%20and%20amber%20palette%2C%20high%20contrast%20cinematic%20tones%2C%20professional%20press%20photography%2C%20gritty%20atmosphere&width=1200&height=760&seq=star-04&orientation=landscape",
  },
  {
    id: 25,
    tag: "明星",
    title: "综艺现场集体沉默的三十秒被拍到，主持人圆场反而越描越黑",
    summary: "一帧帧被网友放大分析，站边与避雷的讨论把这期节目顶上了热门。",
    time: "3 小时前",
    reads: "5.2万",
    image:
      "https://readdy.ai/api/search-image?query=editorial%20press%20photo%20of%20an%20empty%20television%20variety%20show%20studio%20set%20with%20panelist%20chairs%20and%20stage%20lights%20off%2C%20warm%20amber%20backlighting%2C%20deep%20shadow%20and%20red%20accent%20tones%2C%20cinematic%20high%20contrast%2C%20professional%20photojournalism%2C%20moody%20atmosphere&width=1200&height=760&seq=star-05&orientation=landscape",
  },
  {
    id: 26,
    tag: "网红",
    title: "百万粉大号一夜之间改名换头像，老粉看懵：这波转型藏了什么",
    summary: "从情感树洞到硬核测评，人设切换快得像没商量，评论区在问是不是团队易主。",
    time: "4 小时前",
    reads: "4.9万",
    image:
      "https://readdy.ai/api/search-image?query=editorial%20photojournalism%20of%20a%20smartphone%20showing%20a%20social%20media%20profile%20edit%20screen%20with%20blurred%20avatar%20and%20name%20fields%2C%20warm%20desk%20lamp%20glow%2C%20deep%20red%20and%20amber%20tone%2C%20dramatic%20high%20contrast%2C%20professional%20press%20photography%2C%20shallow%20depth%20of%20field%2C%20moody&width=1200&height=760&seq=star-06&orientation=landscape",
  },
];

/* 行业秘密 分线流（虚构） */
export const industryNews: Story[] = [
  {
    id: 31,
    tag: "行业",
    title: "剧本围读迟到四十分钟没人敢催：剧组里的人情世故比戏还精彩",
    summary: "打工人视角看剧组，才知道「咖位」两个字能影响几桌盒饭的供应顺序。",
    time: "1 小时前",
    reads: "4.4万",
    image:
      "https://readdy.ai/api/search-image?query=editorial%20photojournalism%20of%20a%20film%20set%20script%20reading%20room%20with%20a%20long%20wooden%20table%20littered%20with%20scripts%20and%20coffee%20cups%20under%20warm%20practical%20lamps%2C%20deep%20red%20and%20amber%20palette%2C%20high%20contrast%20cinematic%20mood%2C%20professional%20press%20photography%2C%20gritty%20backstage%20atmosphere&width=1200&height=760&seq=industry-01&orientation=landscape",
  },
  {
    id: 32,
    tag: "内幕",
    title: "代言续约谈判桌上的一页报价：品牌方和经纪公司谁先松了口",
    summary: "知情人士只透露「价格卡了三轮」，而这页纸背后的拉扯才刚开始。",
    time: "2 小时前",
    reads: "5.6万",
    image:
      "https://readdy.ai/api/search-image?query=editorial%20photojournalism%20of%20a%20conference%20room%20with%20a%20contract%20document%20and%20pen%20on%20a%20polished%20dark%20table%20lit%20by%20warm%20desk%20light%2C%20blurred%20business%20meeting%20in%20background%2C%20deep%20red%20and%20amber%20tones%2C%20high%20contrast%20cinematic%2C%20professional%20magazine%20photography%2C%20shallow%20depth%20of%20field&width=1200&height=760&seq=industry-02&orientation=landscape",
  },
  {
    id: 33,
    tag: "行业",
    title: "路透出来的片酬「白皮书」被删前截图流传，到底谁在放消息",
    summary: "一张截图在三个平台同时扩散又同批被撤，删得越快，追的人越多。",
    time: "3 小时前",
    reads: "6.1万",
    image:
      "https://readdy.ai/api/search-image?query=editorial%20press%20photo%20of%20a%20printed%20report%20with%20blurred%20numbers%20and%20redaction%20marks%20held%20over%20a%20dark%20surface%2C%20warm%20amber%20lighting%2C%20deep%20red%20accent%20tones%2C%20high%20contrast%20cinematic%20mood%2C%20professional%20photojournalism%2C%20mysterious%20atmosphere&width=1200&height=760&seq=industry-03&orientation=landscape",
  },
  {
    id: 34,
    tag: "内幕",
    title: "线下签售三小时空场：是粉丝经济降温，还是场馆安排埋了雷",
    summary: "主办方晒出的报名数与到场数对不上，退票率成了本轮讨论的焦点。",
    time: "4 小时前",
    reads: "3.9万",
    image:
      "https://readdy.ai/api/search-image?query=editorial%20photojournalism%20of%20an%20empty%20indoor%20event%20venue%20with%20long%20queue%20stanchion%20bars%20and%20a%20distant%20signing%20table%20under%20dim%20warm%20lights%2C%20deep%20red%20and%20amber%20tone%2C%20high%20contrast%20cinematic%2C%20professional%20press%20photography%2C%20melancholic%20atmosphere&width=1200&height=760&seq=industry-04&orientation=landscape",
  },
  {
    id: 35,
    tag: "行业",
    title: "又一部剧官宣即杀青：边拍边剪，宣发团队天天在改档期海报",
    summary: "档期一改再改，海报做了三版没敢发，知情人士说「一切都是待定」。",
    time: "5 小时前",
    reads: "4.2万",
    image:
      "https://readdy.ai/api/search-image?query=editorial%20press%20photo%20of%20a%20film%20marketing%20poster%20design%20desk%20with%20stacked%20printed%20poster%20drafts%20and%20a%20laptop%20showing%20editing%20software%2C%20warm%20amber%20desk%20lamp%2C%20deep%20red%20accents%2C%20high%20contrast%20cinematic%20mood%2C%20professional%20photojournalism%2C%20cluttered%20creative%20atmosphere&width=1200&height=760&seq=industry-05&orientation=landscape",
  },
  {
    id: 36,
    tag: "内幕",
    title: "红毯赞助名单出炉又被秒撤：品牌方和主办方之间到底谁反悔了",
    summary: "名单来来回回改了三版，官博删删发发，热心网友全程帮忙盯梢记录。",
    time: "6 小时前",
    reads: "3.6万",
    image:
      "https://readdy.ai/api/search-image?query=editorial%20photojournalism%20of%20a%20luxury%20event%20sponsorship%20board%20with%20brand%20logos%20blurred%20at%20night%20behind%20velvet%20ropes%2C%20warm%20golden%20and%20deep%20red%20lighting%2C%20high%20contrast%20cinematic%20tone%2C%20professional%20press%20photography%2C%20glamorous%20yet%20moody%20atmosphere&width=1200&height=760&seq=industry-06&orientation=landscape",
  },
];

/* 猛料热榜（虚构） */
export const hotRanking: Story[] = [
  {
    id: 41,
    tag: "热榜",
    title: "顶流机场被围堵的实况录像流出，谁在背后安排这场「偶遇」",
    summary: "路线被提前拿到，围堵点位过于精准，经纪团队称「已报警处理」但外界仍有疑问。",
    time: "1 小时前",
    reads: "15.2万",
    hot: 98,
  },
  {
    id: 42,
    tag: "热榜",
    title: "直播间「全网最低价」翻车复盘：比价截图一出，粉丝当场破防",
    summary: "同款在官方渠道反而更便宜，主播道歉视频发了三次才删对重点。",
    time: "2 小时前",
    reads: "13.8万",
    hot: 95,
  },
  {
    id: 43,
    tag: "热榜",
    title: "某部戏的番位海报被指偷换顺序，主角粉丝连夜做对比图开撕",
    summary: "三张海报放大镜式对比，官微秒删重发，越删越让两边都觉得自己亏了。",
    time: "3 小时前",
    reads: "11.4万",
    hot: 91,
  },
  {
    id: 44,
    tag: "热榜",
    title: "恋情传闻发酵整夜，双方都只发emoji：这波「体面官宣」能信几分",
    summary: "全程没说一个字，全靠两个表情包让评论区吵出上万条解读。",
    time: "4 小时前",
    reads: "10.1万",
    hot: 87,
  },
  {
    id: 45,
    tag: "热榜",
    title: "网红公司离职员工爆料茶水间日常：坐班制度比想象中更严格",
    summary: "一段离职员工录制的内部作息表在网上流传，评论区直呼「卷出新高度」。",
    time: "5 小时前",
    reads: "8.7万",
    hot: 82,
  },
  {
    id: 46,
    tag: "热榜",
    title: "又一档旅游综艺定档在即，飞行嘉宾名单被传得越传越离谱",
    summary: "从素人到顶流猜了个遍，节目组只放出一句「会有惊喜」吊足胃口。",
    time: "6 小时前",
    reads: "7.9万",
    hot: 78,
  },
];

/* 短讯快报（虚构） */
export const flashNews: Story[] = [
  {
    id: 51,
    tag: "快讯",
    title: "新剧开机路透图曝光，主演阵容与早前传闻基本吻合",
    time: "6 分钟前",
    reads: "1.2万",
  },
  {
    id: 52,
    tag: "快讯",
    title: "经纪公司连发三条声明：措辞从「将追责」到「请勿扩散」",
    time: "14 分钟前",
    reads: "9800",
  },
  {
    id: 53,
    tag: "快讯",
    title: "某品牌直播开播即秒空，选品团队连夜开会补货",
    time: "22 分钟前",
    reads: "7600",
  },
  {
    id: 54,
    tag: "快讯",
    title: "红毯造型师发文「下一场见真章」，被解读为回应造型争议",
    time: "31 分钟前",
    reads: "6400",
  },
  {
    id: 55,
    tag: "快讯",
    title: "真人秀花絮放出未播画面，弹幕集体刷起「导演把完整版交出来」",
    time: "42 分钟前",
    reads: "8800",
  },
  {
    id: 56,
    tag: "快讯",
    title: "两档同题材综艺撞档，制作方隔空喊话营销火拼白热化",
    time: "55 分钟前",
    reads: "7100",
  },
];

/* 追更小报（侧栏短讯，虚构） */
export const watchNotes: string[] = [
  "已持续跟进：头部主播选品争议事件，售后进度本周更新",
  "你关注的「某顶流商务去留」有新动态，点开即看完整梳理",
  "追更提醒：待播剧改档传闻又加一集，别错过最新反转",
  "本站持续收录行业报价与签约传闻，证据链式复盘逐条上新",
];

/* FAQ（虚构，信任侧更醒目） */
export const faqs: { q: string; a: string }[] = [
  {
    q: "每日黑料上的内容都真实可信吗？",
    a: "本站以「每日黑料独家曝光 / 每日黑料大曝光」为信息抓手，每条均由编辑对多方渠道做交叉核对后再呈现，并会标注来源可信度与待证实状态。对尚无定论的猛料，我们一律用「曝料 / 传闻 / 待回应」措辞，绝不把猜测定成实锤。",
  },
  {
    q: "想抢在别人之前吃瓜，有什么最快的办法？",
    a: "锁定每日黑料首页即可：全站快讯条实时滚动最新动态，头版头条与独家猛料优先更新，配合猛料热榜让你一眼看清今天大家都在追什么。我们每一条都为您精选。",
  },
  {
    q: "看到涉及自己的不实内容可以申诉吗？",
    a: "可以。本站重视内容事实与隐私边界，若你认为某条曝光存在事实出入或涉及误解，可通过页面底部联系方式说明情况，编辑会在核实后据实更正或标注更新。",
  },
  {
    q: "会一直持续更新、不会有断更吗？",
    a: "黑料曝光台主打「最新猛料持续更新」。我们保持高频快讯 + 深度复盘双轨运作，热点事件会一路追更到尘埃落定，不会在半途戛然而止。",
  },
  {
    q: "站内按钮点了没反应，是我操作错了吗？",
    a: "当前版本为内容展示站，榜单、卡片与追更按钮用于呈现信息形态，暂不接入登录与评论系统。后续如有追更、收藏等能力会统一开放。",
  },
];

/* 页脚快速链接 */
export const footerLinks: { title: string; items: string[] }[] = [
  { title: "栏目", items: ["头版头条", "独家猛料", "明星网红", "行业秘密", "猛料热榜"] },
  { title: "关于本站", items: ["每日黑料说明", "内容核实标准", "投稿与爆料", "编辑团队"] },
  { title: "追更工具", items: ["快讯推送", "热榜提醒", "收藏夹", "历史回溯"] },
];

/* 关键词标签（自然分布，用于页脚信息区） */
export const tagCloud: string[] = [
  "每日黑料",
  "每日黑料独家曝光",
  "每日黑料大曝光",
  "每日黑料爆料",
  "黑料曝光台",
  "最新猛料",
  "娱乐曝料",
  "行业秘密",
];